import React from 'react';
import { connect } from 'react-redux';
import { Outlet } from 'react-router';
import {
  NavigationSide,
  NavigationSideItem,
  viBaselineAudio,
  viBaselineVisual,
  viEvent,
} from 'vibeguide';

function ProgramsContainer({
  user,
}) {
  const viewBaselines = user.can('baseline.view');
  const viewEvents = user.can('event.view');

  return (
    <div
      className="ProgramsContainer"
      style={{
        height: '100%',
        marginLeft: '80px',
      }}
    >
      <NavigationSide>
        <NavigationSideItem
          text="Audio Baselines"
          url="/programs/baselines/audio"
          icon={viBaselineAudio}
          show={viewBaselines}
          testId="programs-nav-audio-baselines"
        />

        <NavigationSideItem
          text="Visual Baselines"
          url="/programs/baselines/visual"
          icon={viBaselineVisual}
          show={viewBaselines}
          testId="programs-nav-visual-baselines"
        />

        <NavigationSideItem
          text="Events"
          url="/programs/events"
          icon={viEvent}
          show={viewEvents}
          testId="programs-nav-events"
        />
      </NavigationSide>

      <Outlet />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(ProgramsContainer);
